module.exports = __webpack_public_path__ + "img/81c789ce33e64692affbc2601f822be5-1024.229660b8.jpg";